import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./App";
import store from "./redux/store/index";
import { BrowserRouter, Route } from "react-router-dom";
import { ScreenLoading } from "./components/loading";
import { initSentry } from "./components/tracking";
import "./i18n";
import "normalize.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "antd/dist/antd.css";
import "./style/index.scss";
import LocalizedRouter from "./routes/localizedRouter";
import ScrollToTop from "./routes/scrollToTop";
import { initGTM } from "./components/tracking/GTM";

initSentry();
initGTM();

ReactDOM.render(
  <Provider store={store}>
    <Suspense fallback={<ScreenLoading />}>
      <React.StrictMode>
        <LocalizedRouter RouterComponent={BrowserRouter}>
          <ScrollToTop />
          <Route path="/" component={App} />
        </LocalizedRouter>
      </React.StrictMode>
    </Suspense>
  </Provider>,
  document.getElementById("root")
);

if (import.meta.hot) {
  import.meta.hot.accept();
}
